import React, { useEffect } from "react";
import { Link } from "react-router-dom";

const Slide13 = () => {
  useEffect(()=>{
    const endButton = document.getElementById('endButton');
    if (endButton) {
      endButton.addEventListener('click', function() {
        window.parent.postMessage('redirectToLink', '*');
      });
    }
    return () => {
      if (endButton) {
        endButton.removeEventListener('click', function() {
          window.parent.postMessage('redirectToLink', '*');
        });
      }
    };
  },[]);
  return (
    <>
      <div className="form-container">
        <div className="step-section">
          <h1>Thank you</h1>
        </div>
      </div>
      <div className="form-container">
        <div>
          <img src="/images/thank-you.svg" width="182" alt="G1" />
        </div>
      </div>
      <div className="form-container">
        <div className="subtitle-thankyou">
          <span>
            We've received your quote request, and will be in touch with a
            <br className="text-br" />
            personalized estimate for your service (typically within a couple
            hours.)
          </span>
        </div>
      </div>
      <div className="form-container mini-text-center">
        <div className="subtitle-thankyou">
          <span>We can't wait to be of service!</span>
        </div>
        <a href="javascript:void(0);"  id="endButton">
          <span
            type="submit"
            className={`btn`}
          >
            Back to Home
          </span> 
        </a>
      </div>
      <input type="hidden" id="progress_slide_1" data-width="100%"/>
    </>
  );
};

export default Slide13;
